<template>
  <form class="logs-form generator-form">
    <div class="logs-top">
      <p class="desc">Тип события</p>
      <button type="button" class="reload-btn">
        Обновить
        <reload-icon></reload-icon>
      </button>
    </div>
    <div class="select-wrap">
      <div class="select-cont small-cont select-cont_top">
        <v-select :options="logTypes"
                  :clearable="false"
                  :searchable="false"
                  :filterable="false"
                  :close-on-select="true"
                  :select-on-tab="true"
                  @input="checkLogs"
                  v-model="activeItem"></v-select>
      </div>
      <div class="select-cont big-cont select-cont_top">
        <v-select :options="intervals"
                  :clearable="false"
                  :searchable="false"
                  :filterable="false"
                  :close-on-select="true"
                  :select-on-tab="true"
                  v-model="activeInterval"></v-select>
      </div>
    </div>
    <div class="custom-scrollbar">
      <ul class="log-table"
          v-if="showLogs">
        <li class="legend">
          <div class="col1">
            Время
          </div>
          <div class="col2">
            Пользователь
          </div>
          <div class="col3">
            Тип
          </div>
          <div class="col4">
            Статус
          </div>
          <div class="col5">
            Подробности
          </div>
        </li>
        <li class="log-item desc"
            v-for="log in filteredLogs">
          <div class="col1">
            {{log.time}}
          </div>
          <div class="col2">
            {{log.user}}
          </div>
          <div class="col3">
            {{log.type}}
          </div>
          <div class="col4">
            {{log.status}}
          </div>
          <div class="col5">
            {{log.more}}
          </div>
        </li>
      </ul>
    </div>
    <vue-slide-bar :max="256"
                   v-if="showLogs"
                   class="vue-slidebar"
                   v-model="progress"
                   :processStyle="{backgroundColor: '#29ABE2'}"
                   @input="setRange"
                   :speed="0"
                   :min="0">

    </vue-slide-bar>
  </form>
</template>

<script>
  import reloadIcon from '../../../Svg/reload'
  import {mapState} from 'vuex'

  export default {
    name: 'logs',
    components: {
      reloadIcon,
    },
    data() {
      return {
        userLogs: '',
        activeItem: 'Выберите',
        activeInterval: 'Выберите',
        intervals: [
          'Последний 1 день',
          "Последний час"
        ],
        progress: 0
      }
    },
    computed: {
      ...mapState({
        users: state => state.users.users,
        editIndex: state => state.users.editUserIndex
      }),
      logTypes() {
        let arr = new Array();
        for (let  i = 0; i < this.userLogs.length; i++) {
          arr.push(this.userLogs[i].type)
        }
        return arr;
      },
      filteredLogs() {
        let arr = [];
        arr = this.userLogs.filter((item) => {
          return item.type == this.activeItem
        });
        if (arr.length > 0) {
          return arr[0].logs
        } else {
          return []
        }
      },
      showLogs: function () {
        if (this.activeItem != 'Выберите' && this.activeInterval != 'Выберите') {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      checkLogs() {
        if (!this.activeItem) {
          this.activeItem == 'Выберите'
        }
      },
      setScroll(e) {
        let scrollLeft = e.target.scrollLeft;
        this.progress = scrollLeft;
      },
      setRange() {
        let scrollEll = document.querySelector('.log-table');
        scrollEll.scrollLeft = this.progress
      }
    },
    beforeMount() {
      for (let i = 0; i < this.users.length; i++) {
        let item = this.users[i];
        if (item.grid.i == this.editIndex) {
          this.userLogs = item.logs;
          break;
        }
      }
    }
  }
</script>

<style lang="scss" >

</style>
